import { fork } from 'redux-saga/effects'
import { mcSharedSaga } from './shared'
import { mcDocusignSaga } from './docusign'

export function* mcSaga() {
  yield fork(mcSharedSaga)
  yield fork(mcDocusignSaga)
}
